"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _MonotoneChain = _interopRequireDefault(require("./MonotoneChain"));

var _SweepLineEvent = _interopRequireDefault(require("./SweepLineEvent"));

var _EdgeSetIntersector2 = _interopRequireDefault(require("./EdgeSetIntersector"));

var _Collections = _interopRequireDefault(require("../../../../../java/util/Collections"));

var _SegmentIntersector = _interopRequireDefault(require("./SegmentIntersector"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _List = _interopRequireDefault(require("../../../../../java/util/List"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SimpleMCSweepLineIntersector =
/*#__PURE__*/
function (_EdgeSetIntersector) {
  _inherits(SimpleMCSweepLineIntersector, _EdgeSetIntersector);

  function SimpleMCSweepLineIntersector() {
    var _this;

    _classCallCheck(this, SimpleMCSweepLineIntersector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleMCSweepLineIntersector).call(this));
    SimpleMCSweepLineIntersector.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(SimpleMCSweepLineIntersector, [{
    key: "prepareEvents",
    value: function prepareEvents() {
      _Collections.default.sort(this.events);

      for (var i = 0; i < this.events.size(); i++) {
        var ev = this.events.get(i);

        if (ev.isDelete()) {
          ev.getInsertEvent().setDeleteEventIndex(i);
        }
      }
    }
  }, {
    key: "computeIntersections",
    value: function computeIntersections() {
      if (arguments.length === 1) {
        var si = arguments[0];
        this.nOverlaps = 0;
        this.prepareEvents();

        for (var i = 0; i < this.events.size(); i++) {
          var ev = this.events.get(i);

          if (ev.isInsert()) {
            this.processOverlaps(i, ev.getDeleteEventIndex(), ev, si);
          }

          if (si.isDone()) {
            break;
          }
        }
      } else if (arguments.length === 3) {
        if (arguments[2] instanceof _SegmentIntersector.default && (0, _hasInterface.default)(arguments[0], _List.default) && (0, _hasInterface.default)(arguments[1], _List.default)) {
          var edges0 = arguments[0],
              edges1 = arguments[1],
              _si = arguments[2];
          this.addEdges(edges0, edges0);
          this.addEdges(edges1, edges1);
          this.computeIntersections(_si);
        } else if (typeof arguments[2] === "boolean" && (0, _hasInterface.default)(arguments[0], _List.default) && arguments[1] instanceof _SegmentIntersector.default) {
          var edges = arguments[0],
              _si2 = arguments[1],
              testAllSegments = arguments[2];
          if (testAllSegments) this.addEdges(edges, null);else this.addEdges(edges);
          this.computeIntersections(_si2);
        }
      }
    }
  }, {
    key: "addEdge",
    value: function addEdge(edge, edgeSet) {
      var mce = edge.getMonotoneChainEdge();
      var startIndex = mce.getStartIndexes();

      for (var i = 0; i < startIndex.length - 1; i++) {
        var mc = new _MonotoneChain.default(mce, i);
        var insertEvent = new _SweepLineEvent.default(edgeSet, mce.getMinX(i), mc);
        this.events.add(insertEvent);
        this.events.add(new _SweepLineEvent.default(mce.getMaxX(i), insertEvent));
      }
    }
  }, {
    key: "processOverlaps",
    value: function processOverlaps(start, end, ev0, si) {
      var mc0 = ev0.getObject();

      for (var i = start; i < end; i++) {
        var ev1 = this.events.get(i);

        if (ev1.isInsert()) {
          var mc1 = ev1.getObject();

          if (!ev0.isSameLabel(ev1)) {
            mc0.computeIntersections(mc1, si);
            this.nOverlaps++;
          }
        }
      }
    }
  }, {
    key: "addEdges",
    value: function addEdges() {
      if (arguments.length === 1) {
        var edges = arguments[0];

        for (var i = edges.iterator(); i.hasNext();) {
          var edge = i.next();
          this.addEdge(edge, edge);
        }
      } else if (arguments.length === 2) {
        var _edges = arguments[0],
            edgeSet = arguments[1];

        for (var i = _edges.iterator(); i.hasNext();) {
          var edge = i.next();
          this.addEdge(edge, edgeSet);
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SimpleMCSweepLineIntersector;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return SimpleMCSweepLineIntersector;
}(_EdgeSetIntersector2.default);

exports.default = SimpleMCSweepLineIntersector;

SimpleMCSweepLineIntersector.constructor_ = function () {
  this.events = new _ArrayList.default();
  this.nOverlaps = null;
};